import ListView from '../../../components/ListView';

const breadcrumbItems = [
  { label: 'Home', href: '/dashboard' },
  { label: 'Jobs' },
];

export default function JobsListPage() {
  return <ListView moduleName="job" breadcrumbItems={breadcrumbItems} />;
}
